export interface QrOptions {
  sizeMm: number;
  eclevel: 'L' | 'M' | 'Q' | 'H';
  dpi: number;
  quietZone: number;
  logoFilename?: string;
  logoAssetId?: string;
  logoSizePercent: number;
}

export const DEFAULT_QR_OPTIONS: QrOptions = {
  sizeMm: 25,
  eclevel: 'M',
  dpi: 600,
  quietZone: 4,
  logoSizePercent: 20,
};

export interface QrGenerateResult {
  success: boolean;
  replaced: boolean;
  asset: {
    _id: string;
    fileName: string;
    title: string;
    previewPaths?: { thumbnail?: string; medium?: string };
  };
  downloadUrl: string;
}

export interface QrListItem {
  _id: string;
  fileName: string;
  title: string;
  tags: string[];
  metadata: Record<string, any>;
  previewPaths?: { thumbnail?: string; medium?: string };
  uploadedAt: string;
  fileSize: number;
}
